export const UPDATE_PROFILE_SUCCESS = 'UPDATE_PROFILE_SUCCESS'
export const UPDATE_EMAIL = 'UPDATE_EMAIL'
export const GET_PROFILE = 'GET_PROFILE'
export const UPDATE_ACCOUNT_SUPSCRIPTION = 'UPDATE_ACCOUNT_SUPSCRIPTION'
